"use client";

import { createContext } from "react";
import type { Catalog } from "./catalogs";
import { type AppLocale, DEFAULT_LOCALE } from "./config";

export interface LocaleContextValue {
  locale: AppLocale;
  /** The locale's loaded catalog; English has none. */
  catalog?: Catalog;
}

/** The portal's language for `useExtracted()`; English everywhere else. */
export const LocaleContext = createContext<LocaleContextValue>({ locale: DEFAULT_LOCALE });
